<template>
  <div>
    <div v-if="!restoring">

      <p>Det tas en backup på din Bridge en gång per dag och dessa sparas under sju dagar, du kan alltså återställa din data till vilken Bridge som helst på ditt konto sju dagar tillbaka. Om du trycker på <i>Återställ</i> nedanför kommer datan att laddas ner till den Bridge du är <strong>ansluten på just nu</strong>.
      
      <span style="color:red;">Dina Z-Wave-enheter kommer <strong>inte</strong> att återställas då det inte går att exportera dessa.</span></p>      
      
      <h4 v-if="!selectedBridge.length">Välj en Nexa Bridge att återställa <i>från</i></h4>
      
      <table v-if="list.length && bridges.length && !selectedBridge.length">
        <tbody>
          <tr v-for="item in list" :value="item.bridgeId" v-if="item.backups.length" @click="selectedBridge = item.bridgeId">
            <td>{{ bridgeName(item.bridgeId) }}</td>
            <td align="right">&rarr;</td>
          </tr>
        </tbody>
      </table>
      

      <h4 v-if="selectedBridge.length" style="margin-top:14px;">Återställ från "{{ bridgeName(selectedBridge) }}"</h4>
      
      <table v-if="selectedBridge.length" style="margin-top:6px;">
        <thead>
          <th colspan="2">Datum</th>        
        </thead>
        
        
        
        <tbody>
          <tr v-for="backup in list.find(i => i.bridgeId == selectedBridge).backups">
            <td>{{ backup.added | moment("dddd (YYYY-MM-DD)") }}</td>
            <td align="right" @click="restore(backup)">Återställ</td>
          </tr>
        </tbody>
      </table>
      
    </div>
    <div v-else>
      <div style="padding-left:45%;padding-top:1em;" v-if="!restored">
        <h4>Återställer...</h4>
        
        <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
      </div>
      <div v-else> 
        <h4>Nexa Bridge återställd</h4>
        
        <p>Din Nexa Bridge har återställts och kommer nu att startas om. Vänta några minuter och ladda sedan om sidan så kommer du se dina enheter. Du behöver också starta om eventuella appar för att all data skall laddas ned.</p>
      </div>
    </div>

    
  </div>
</template>

<script>
  import { HTTP, cloud } from '../http.js'
  import { HalfCircleSpinner } from 'epic-spinners'

  export default {
    name: 'installningar_backups',
    components: {
      HalfCircleSpinner
    },
    data () {
      return {
        list: [],
        selectedBridge: '',
        restoring: false,
        bridges: [],
        restored: false
      }
    },
    async created () {
      this.list = (await cloud.get('bridges/backups')).data
      this.bridges = (await cloud.get('bridges')).data

      if (this.list.length == 1) {
        this.selectedBridge = this.list[0].bridgeId
      }

    },
    methods: {
      async restore (backup) {
        if (confirm('Är du säker på att du återställa denna backup till den Bridgen du är ansluten till just nu?')) {
          if (confirm('Är du 100% säker? Din Bridge kommer att startas om när återställningen är klar')) {
            this.restoring = true

            const { data } = await HTTP.post('backup/get?excludeZWave=1&id=' + backup.id)

            if ('status' in data && data.status === 'OK') {
              this.restored = true
              
              HTTP.post('actions/restartnx')
            }
          }
        }
      },

      bridgeName (bridgeId) {
        const bridge = this.bridges.find(x => x.id === bridgeId)
        return bridge ? bridge.name : ''
      },
      
      bridgeGen (bridgeId) {
        const bridge = this.bridges.find(x => x.id === bridgeId)
        return bridge ? (bridge.info.systemType === 'Bridge2' ? 'gen 2' : 'gen 1') : ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_backups.vue